const initialState = {
  sitesOnTestCount: null,
  warningSiteOnTest: null,
  loadingSitesOnTestCount: null,
  data : {
    onTest: [],
    pagination: {
      count: 0,
      pageCount: 1,
    },
  },
  requestPageNumber: 1,
  pageSize: 20,
  sortField: "time_out",
  sortDirection: "asc",
  filters: [],
  nextRefresh: null,
  lastRefresh: null,
  loadingSitesOnTest: null,
};

const sitesOnTest = (state = initialState, action) => {
  switch (action.type) {

    // sites on test count
    case "LOAD_SITES_ON_TEST_COUNT_START":
      return {
        ...state,
        loadingSitesOnTestCount: true,
      };

    case "LOAD_SITES_ON_TEST_COUNT_SUCCESS":
      return {
        ...state,
        sitesOnTestCount: action.data ? action.data.sitesOnTest : 0,
        warningSiteOnTest: action.data ? action.data.warningSiteOnTest : 0,
        loadingSitesOnTestCount: false,
      }

    case "LOAD_SITES_ON_TEST_COUNT_FAILED":
      return {
        ...state,
        loadingSitesOnTestCount: false,
      };

    case "LOAD_SITES_ON_TEST_COUNT_CANCEL":
      return {
        ...state,
        loadingSitesOnTestCount: false,
      };

    // sites on test count live refresh
    case "LOAD_SITES_ON_TEST_COUNT_REFRESH_START":
      return {
        ...state,
        loadingSitesOnTestCount: true,
      };

    case "LOAD_SITES_ON_TEST_COUNT_REFRESH_SUCCESS":
      return {
        ...state,
        sitesOnTestCount: action.data ? action.data.sitesOnTest : 0,
        warningSiteOnTest: action.data ? action.data.warningSiteOnTest : 0,
        loadingSitesOnTestCount: false,
      }

    case "LOAD_SITES_ON_TEST_COUNT_REFRESH_FAILED":
      return {
        ...state,
        loadingSitesOnTestCount: false,
      };

    case "LOAD_SITES_ON_TEST_COUNT_REFRESH_CANCEL":
      return {
        ...state,
        loadingSitesOnTestCount: false,
      };

    // sites on test
    case "LOAD_SITES_ON_TEST_START":
      return {
        ...state,
        loadingSitesOnTest: true,
      };

    case "LOAD_SITES_ON_TEST_SUCCESS":
      return {
        ...state,
        // the request data
        data: action.data ? { ...action.data } : {
          onTest: [],
          pagination: {
            count: 0,
            pageCount: 1,
          },
        },
        // store any changes to the request parameters that came in on the action so that the live refresh can use them
        requestPageNumber: action.startAction.requestPageNumber || 1,
        pageSize: action.startAction.pageSize || 20,
        sortField: action.startAction.sortField || null,
        sortDirection: action.startAction.sortDirection || "desc",
        filters: [
          ...action.startAction.filters
        ] || [],
        loadingSitesOnTest: false,
      }

    case "LOAD_SITES_ON_TEST_FAILED":
      return {
        ...state,
        loadingSitesOnTest: false,
      };

    case "LOAD_SITES_ON_TEST_CANCEL":
      return {
        ...state,
        loadingSitesOnTest: false,
      };

    // sites on test live refresh
    case "LOAD_SITES_ON_TEST_REFRESH_START":
      return {
        ...state,
        loadingSitesOnTest: true,
      };

    case "LOAD_SITES_ON_TEST_REFRESH_SUCCESS":
      return {
        ...state,
        // the latest request data
        data: action.data ? { ...action.data } : {
          onTest: [],
          pagination: {
            count: 0,
            pageCount: 1,
          },
        },
        // live refresh doesn't change the request parameters
        // pageSize: action.startAction.pageSize || 20,
        // sortField: action.startAction.sortField || null,
        // sortDirection: action.startAction.sortDirection || "desc",
        // filters: [
        //   ...action.startAction.filters
        // ] || [],
        lastRefresh: action.lastRefresh,
        nextRefresh: action.nextRefresh,
        loadingSitesOnTest: false,
      }

    case "LOAD_SITES_ON_TEST_REFRESH_FAILED":
      return {
        ...state,
        loadingSitesOnTest: false,
      };

    case "LOAD_SITES_ON_TEST_REFRESH_CANCEL":
      return {
        ...state,
        loadingSitesOnTest: false,
      };

    // clear sites on test
    case "CLEAR_SITES_ON_TEST":
      return {
        ...initialState,
      }

    default:
      return state;
  }
};

export default sitesOnTest;